export { GroupNewsfeedAndAnnouncementsLayout } from './layout.jsx'
